@charset "UTF-8";

/* app/js/src/components/clipping-studio/auto-reframe-modal/clipping-studio-auto-reframe-modal.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.auto-reframe-modal__clip-strip::-webkit-scrollbar,
.auto-reframe-modal__sidebar::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.auto-reframe-modal__clip-strip::-webkit-scrollbar-button,
.auto-reframe-modal__sidebar::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.auto-reframe-modal__clip-strip::-webkit-scrollbar-corner,
.auto-reframe-modal__sidebar::-webkit-scrollbar-corner {
  background: transparent;
}
.auto-reframe-modal__clip-strip::-webkit-scrollbar-thumb:hover,
.auto-reframe-modal__sidebar::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.auto-reframe-modal__clip-strip::-webkit-scrollbar-thumb,
.auto-reframe-modal__sidebar::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.auto-reframe-modal__clip-strip::-webkit-scrollbar-thumb:hover,
.auto-reframe-modal__sidebar::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.auto-reframe-modal__clip-strip::-webkit-scrollbar-track:hover,
.auto-reframe-modal__sidebar::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.auto-reframe-modal__clip-strip::-webkit-scrollbar-track,
.auto-reframe-modal__sidebar::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.auto-reframe-modal {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.08);
  font-family: "Open Sans", sans-serif;
  color: rgba(0, 0, 0, 0.85);
}
.auto-reframe-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  background: rgb(235, 240, 244);
  border-radius: 4px 4px 0 0;
}
.auto-reframe-modal__header-titles {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.auto-reframe-modal__title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1.3;
  color: rgba(0, 0, 0, 0.85);
}
.auto-reframe-modal__subtitle {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
}
.auto-reframe-modal__btn--exit {
  font-size: 13px;
  padding: 8px 14px;
}
.auto-reframe-modal__btn {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.14);
  color: rgba(0, 0, 0, 0.85);
}
.auto-reframe-modal__btn:hover:not(:disabled) {
  background: rgb(235, 240, 244);
}
.auto-reframe-modal__btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}
.auto-reframe-modal__btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.auto-reframe-modal__btn--primary {
  background: #e87500;
  color: #fff;
  border-color: #e87500;
}
.auto-reframe-modal__btn--primary:hover:not(:disabled) {
  background: #c96600;
}
.auto-reframe-modal__btn--secondary {
  background: transparent;
}
.auto-reframe-modal__btn--secondary:hover:not(:disabled) {
  background: rgb(235, 240, 244);
}
.auto-reframe-modal__btn--chip {
  padding: 6px 12px;
  margin-right: 8px;
  margin-bottom: 4px;
}
.auto-reframe-modal__btn--chip-active {
  background: rgb(45, 187, 252);
  color: #fff;
  border-color: rgb(45, 187, 252);
}
.auto-reframe-modal__main {
  display: flex;
  flex: 1;
  min-height: 0;
  background: #f1f3f4;
}
.auto-reframe-modal__section-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.54);
  margin-bottom: 8px;
}
.auto-reframe-modal__canvases {
  display: flex;
  gap: 28px;
  flex: 1;
  min-width: 0;
  min-height: 0;
  padding: 20px;
  align-items: stretch;
  justify-content: center;
}
.auto-reframe-modal__source-col,
.auto-reframe-modal__output-col {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-width: 0;
}
.auto-reframe-modal__source-col {
  flex-shrink: 0;
}
.auto-reframe-modal__output-col {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.auto-reframe-modal__output-col .auto-reframe-modal__output-wrap {
  flex: 1;
  min-height: 0;
}
.auto-reframe-modal__source-hint {
  margin: 8px 0 0;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
  line-height: 1.4;
}
.auto-reframe-modal__source-wrap {
  position: relative;
  width: 520px;
  flex-shrink: 0;
  aspect-ratio: 16/9;
  background: #f1f3f4;
  border-radius: 4px;
  overflow: hidden;
}
.auto-reframe-modal__source-video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  background: #000;
}
.auto-reframe-modal__source-video--hidden {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
  overflow: hidden;
}
.auto-reframe-modal__source-overlay {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  cursor: crosshair;
}
.auto-reframe-modal__source-overlay--resizing {
  cursor: nwse-resize;
}
.auto-reframe-modal__source-overlay--readonly {
  pointer-events: none;
  cursor: default;
}
.auto-reframe-modal__output-wrap {
  width: 280px;
  min-height: 240px;
  max-width: 100%;
  max-height: 100%;
  flex: 1;
  flex-shrink: 1;
  align-self: stretch;
  background: #f1f3f4;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.auto-reframe-modal__output-canvas {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  display: block;
}
.auto-reframe-modal__sidebar {
  width: 280px;
  flex-shrink: 0;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  padding: 16px;
  overflow-y: auto;
  background: rgb(235, 240, 244);
}
.auto-reframe-modal__panel {
  margin-bottom: 16px;
}
.auto-reframe-modal__adjustment-mode {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.auto-reframe-modal__ai-badge {
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.05em;
  color: #7c3aed;
  background: rgba(124, 58, 237, 0.12);
  padding: 4px 8px;
  border-radius: 4px;
}
.auto-reframe-modal__adjustment-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.auto-reframe-modal__adjustment-option {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 12px;
  border-radius: 12px;
  border: 2px solid rgba(0, 0, 0, 0.14);
  background: rgb(255, 255, 255);
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.auto-reframe-modal__adjustment-option:hover {
  border-color: rgba(0, 0, 0, 0.14);
}
.auto-reframe-modal__adjustment-option--active {
  border-color: rgb(45, 187, 252);
  background: rgba(45, 187, 252, 0.06);
  box-shadow: 0 0 0 1px rgb(45, 187, 252);
}
.auto-reframe-modal__adjustment-option-title {
  font-size: 13px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
}
.auto-reframe-modal__adjustment-option-desc {
  font-size: 11px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
}
.auto-reframe-modal__panel-title {
  margin: 0 0 14px 0;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1.3;
  color: rgba(0, 0, 0, 0.85);
}
.auto-reframe-modal__btn--reset {
  margin-bottom: 12px;
}
.auto-reframe-modal__field {
  margin-bottom: 12px;
}
.auto-reframe-modal__label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.54);
  margin-bottom: 6px;
}
.auto-reframe-modal__radios {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.auto-reframe-modal__radio {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
}
.auto-reframe-modal__btn-group {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.auto-reframe-modal__actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
}
.auto-reframe-modal__bottom {
  padding: 14px 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  background: rgb(235, 240, 244);
  border-radius: 0 0 4px 4px;
}
.auto-reframe-modal__clip-strip-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.auto-reframe-modal__clip-strip-status {
  font-size: 13px;
  font-weight: 600;
  color: #0d7d4a;
}
.auto-reframe-modal__clip-strip {
  display: flex;
  gap: 12px;
  margin-bottom: 14px;
  overflow-x: auto;
  padding-bottom: 4px;
  min-height: 100px;
}
.auto-reframe-modal__clip-thumb {
  flex-shrink: 0;
  padding: 8px 12px;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  border: 2px solid rgba(0, 0, 0, 0.14);
  border-radius: 4px;
  background: rgb(255, 255, 255);
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 120px;
  position: relative;
}
.auto-reframe-modal__clip-thumb:hover {
  background: rgb(235, 240, 244);
}
.auto-reframe-modal__clip-thumb.auto-reframe-modal__clip-thumb--with-image {
  padding: 0;
  width: 128px;
  min-height: 0;
  overflow: visible;
}
.auto-reframe-modal__clip-thumb.auto-reframe-modal__clip-thumb--with-image .auto-reframe-modal__clip-thumb-img {
  width: 100%;
  height: 72px;
  object-fit: cover;
  display: block;
}
.auto-reframe-modal__clip-thumb.auto-reframe-modal__clip-thumb--with-image .auto-reframe-modal__clip-thumb-label,
.auto-reframe-modal__clip-thumb.auto-reframe-modal__clip-thumb--with-image .auto-reframe-modal__clip-thumb-duration {
  padding: 4px 6px 6px;
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}
.auto-reframe-modal__clip-thumb.auto-reframe-modal__clip-thumb--with-image .auto-reframe-modal__clip-thumb-duration {
  font-size: 11px;
  padding-top: 0;
}
.auto-reframe-modal__clip-thumb .auto-reframe-modal__clip-thumb-fallback {
  padding: 12px 8px;
}
.auto-reframe-modal__clip-thumb .auto-reframe-modal__clip-thumb-label {
  font-size: 12px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.54);
}
.auto-reframe-modal__clip-thumb .auto-reframe-modal__clip-thumb-duration {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.54);
}
.auto-reframe-modal__clip-thumb .auto-reframe-modal__clip-thumb-badge {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  text-align: center;
}
.auto-reframe-modal__clip-thumb .auto-reframe-modal__clip-thumb-badge--ai {
  background: #e87500;
}
.auto-reframe-modal__clip-thumb .auto-reframe-modal__clip-thumb-badge--manual {
  background: rgba(45, 187, 252, 0.9);
}
.auto-reframe-modal__clip-thumb--active {
  border-color: rgb(45, 187, 252);
  background: rgba(45, 187, 252, 0.06);
  box-shadow: 0 0 0 1px rgba(45, 187, 252, 0.3);
}
.auto-reframe-modal__timeline-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.auto-reframe-modal__play-btn {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.14);
  background: rgb(255, 255, 255);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.auto-reframe-modal__play-btn:hover {
  background: rgb(235, 240, 244);
}
.auto-reframe-modal__play-icon {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 7px 0 7px 12px;
  border-color: transparent transparent transparent rgba(0, 0, 0, 0.85);
  margin-left: 3px;
}
.auto-reframe-modal__play-icon.auto-reframe-modal__play-icon--playing {
  width: 3px;
  height: 14px;
  border: none;
  margin-left: -5px;
  background: rgba(0, 0, 0, 0.85);
  box-shadow: 6px 0 0 rgba(0, 0, 0, 0.85);
}
.auto-reframe-modal__time-current {
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  min-width: 42px;
}
.auto-reframe-modal__timeline-meta {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.54);
}
.auto-reframe-modal__clip-duration-label {
  font-weight: 500;
}
.auto-reframe-modal__time-total {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
.auto-reframe-modal__timeline {
  flex: 1;
  height: 24px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 4px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  background-color: rgb(255, 255, 255);
  background-image:
    repeating-radial-gradient(
      circle at 50% 50%,
      rgba(0, 0, 0, 0.14) 0,
      rgba(0, 0, 0, 0.14) 1.5px,
      transparent 1.5px,
      transparent 100%);
  background-size: 10px 24px;
  background-position: 0 0;
}
.auto-reframe-modal__timeline::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 2;
  border-radius: inherit;
  pointer-events: none;
}
.auto-reframe-modal__timeline-fill {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  background: rgba(45, 187, 252, 0.4);
  border-radius: 4px 0 0 4px;
  pointer-events: none;
  z-index: 1;
}
.auto-reframe-modal__timeline-keyframe {
  position: absolute;
  top: 0;
  bottom: 0;
  transform: translateX(-50%);
  width: 3px;
  margin-left: 0;
  padding: 0;
  border: none;
  border-radius: 1px;
  background: rgba(45, 187, 252, 0.6);
  cursor: pointer;
  z-index: 2;
  transition: background 0.15s ease, width 0.15s ease;
}
.auto-reframe-modal__timeline-keyframe:hover {
  background: rgba(45, 187, 252, 0.9);
  width: 4px;
}
.auto-reframe-modal__timeline-keyframe.auto-reframe-modal__timeline-keyframe--selected {
  background: rgb(45, 187, 252);
  width: 4px;
  border-radius: 2px;
}
.auto-reframe-modal__timeline-playhead {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  margin-left: -1px;
  background: rgb(45, 187, 252);
  pointer-events: none;
  z-index: 3;
}
.auto-reframe-modal__timeline-playhead::after {
  content: "";
  position: absolute;
  bottom: 2px;
  top: -4px;
  transform: translateX(-38%);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgb(45, 187, 252);
}
.auto-reframe-modal__stats {
  flex-shrink: 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
  display: flex;
  gap: 12px;
}
/*# sourceMappingURL=clipping-studio-auto-reframe-modal.component.css.map */
